import { useEffect } from 'react'

export default function About() {
  useEffect(() => {
    document.title = 'About Grace Wang | Environmental Equipment Supply'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">COMMERCIAL & PROJECT COORDINATION</p>
        <h1>Meet Grace Wang</h1>
        <p>A consistent China-based contact for clearly defined environmental equipment supply and manufacturing coordination.</p>
      </section>

      <section className="page-content">
        <h2>Background</h2>
        <p>Environmental industry experience with a clear operating boundary</p>
        <p>Grace Wang has more than 10 years of experience in the environmental equipment industry. She serves as the international commercial and project coordination contact for stainless steel and carbon steel fabrication supported by a family-owned manufacturing facility in Yixing.</p>
        <p>For FRP, PP, membrane, wastewater, sludge handling and other specialist equipment, Grace coordinates selected manufacturing partners according to the confirmed equipment scope.</p>
        <p>Grace remains the customer's consistent point of contact for inquiry clarification, proposal coordination, production follow-up, inspection documentation and export communication.</p>

        <h2>Technical Support</h2>
        <p>The Right Engineer Joins Each Technical Review</p>
        <p>When technical clarification is required, the manufacturing or process engineer responsible for that equipment scope joins the review. Grace coordinates commercial communication and written follow-up.</p>
      </section>
    </div>
  )
}
